import { PCCDetailsFile } from "../../interface";
import { ERRORS, SPECIAL_FILE_TYPES } from "./file-upload-widget.constants";
import { FileUploadWidgetConfig } from "./file-upload-widget.interface";

export function buildFilePath(file: PCCDetailsFile, referralId: string) {
  if (!referralId) {
    return;
  }
  const filePath = 'Snfs/AllScripts/' + referralId;
  if (file.source == 'CI') {
    return filePath + '/srcClient/' + file.name;
  } else if (file.source == 'GatewAI') {
    return filePath + '/listFiles/' + file.name;
  } else {
    return filePath + '/srcPdfs/' + file.name;
  }
}

export function validateFiles(files: FileList, config: FileUploadWidgetConfig): string {
  const { acceptedTypes, maxSizeMb } = config;
  if (!acceptedTypes || acceptedTypes.length === 0) {
    return '';
  }
  let error = '';
  const typesLowerCase = acceptedTypes.map(type => type.toLocaleLowerCase());
  for (let i = 0; i < files.length; i++) {
    const type = files[i].type.split('/')?.[1];
    if (!type) {
      continue;
    }
    const normalizedType = SPECIAL_FILE_TYPES[type] ?? type;
    if (!typesLowerCase.includes(normalizedType)) {
      error = ERRORS.FILE_TYPE_NOT_ALLOWED;
      break;
    }
    if (!isFileSizeValid(files[i], maxSizeMb)) {
      error = ERRORS.MAX_SIZE_EXCEEDED;
      break;
    }
  }
  return error;
}

export function isFileSizeValid(file: File, maxSizeMb: number): boolean {
  if (file.size > (maxSizeMb * 1024 * 1024)) {
    return false;
  }
  return true;
}

function splitName(filename) {
  const i = filename.lastIndexOf(".");
  if (i <= 0) return { base: filename, ext: "" };
  return { base: filename.slice(0, i), ext: filename.slice(i) };
}

function escapeRegExp(s) {
  return s.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}

export function uniqueFilename(desiredName: string, existingNames: PCCDetailsFile[]) {
  const { base, ext } = splitName(desiredName);
  const re = new RegExp(
    `^${escapeRegExp(base)}(?:\\_(\\d+))?${escapeRegExp(ext)}$`
  );

  let max = -1;
  for (const n of existingNames) {
    const m = n.name.match(re);
    if (!m) continue;
    const num = m[1] ? Number(m[1]) : 0;
    if (num > max) max = num;
  }
  return max === -1 ? desiredName : `${base}_${max + 1}${ext}`;
}
